import { Switch, Route } from "react-router-dom";

import { remove } from "../src/redux/slices/basketSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import Korolev from "./pages/korolev";

function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(remove());
  }, [location.pathname, dispatch]);

  return (
    <Switch>
      <Korolev />
    </Switch>
  );
}

export default App;
